// import firebase from 'firebase/compat/app';
// import 'firebase/compat/auth';
// import 'firebase/compat/analytics';
// import 'firebase/compat/firestore';
// import { initializeApp } from "firebase/app"
// import { getFirestore } from "firebase/firestore";

// import firebase from 'firebase';
// import 'firebase/firestore';
// import 'firebase/analytics';
// firebase init goes here
// const config = {
//   apiKey: 'AIzaSyDtAqSxnGZSGaaUy-9j2vkXPUFfm17PtGw',
//   authDomain: 'auth.context.so',
//   databaseURL: 'https://context-v5.firebaseio.com',
//   projectId: 'context-v5',
//   storageBucket: 'context-v5.appspot.com',
//   messagingSenderId: '385146739042',
//   appId: '1:385146739042:web:9e64e6dacfa569d5',
//   measurementId: 'G-KEY9TNMP5W'
// };

// const firebaseApp = initializeApp(config);
// const db = getFirestore();
// function initFirebase() {
//   firebase.initializeApp(config);
//   return new Promise((resolve, reject) => {
//     firebase
//       .firestore()
//       .enablePersistence({ synchronizeTabs: false })
//       .then(resolve)
//       .catch(err => {
//         if (err.code === 'failed-precondition') {
//           console.log('multiple tabs open, cache no go');
//           reject(err);
//           // Multiple tabs open, persistence can only be
//           // enabled in one tab at a a time.
//         } else if (err.code === 'unimplemented') {
//           console.log('browser not supported, cache no go')
//           reject(err);
//           // The current browser does not support all of
//           // the features required to enable persistence
//         }
//       });
//     // resolve;
//   });
// }

// initFirebase
// initFirebase().catch(error => {
//   console.log('error initializing firebase', error);
// });

// firebase utils
// const db = firebase.firestore();
// const auth = firebase.auth();
// const providerIds = firebase.auth;
// date issue fix according to firebase
// const settings = {
//   timestampsInSnapshots: true
// };
// db.settings(settings);

// firebase collections
// const usersCollection = db.collection('users');
// const contextsCollection = db.collection('contexts');
// const pagesCollection = db.collection('pages');
// const invitesCollection = db.collection('invites');
// const userSummaryCollection = db.collection('accessSummary');

const fb = {
  paths: {
    function: 'https://us-central1-context-v5.cloudfunctions.net/',
    functionLocal: 'http://localhost:5000/context-v5/us-central1/'
  }
};
// document.gfb = fb;
export default fb;
